import React from "react";
import LegalLayout from "./LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" updated="February 2026" testId="page-terms">
      <h2>1. The service</h2>
      <p>
        ScanMint (&quot;we&quot;, &quot;us&quot;) provides QR vehicle verification
        tools for property managers, restaurants, and businesses
        (&quot;Customer&quot;, &quot;you&quot;). By creating an account, you
        agree to these Terms of Service.
      </p>

      <h2>2. Eligibility &amp; accounts</h2>
      <p>
        You must be at least 18 years old and legally able to enter contracts on
        behalf of your business. You are responsible for keeping your login
        credentials secure and for all activity on your account.
      </p>

      <h2>3. Pricing &amp; billing</h2>
      <ul>
        <li>
          <strong>Setup fee:</strong> A one-time setup fee of <strong>$99 USD</strong>{" "}
          is charged before your first property is fully activated. The setup
          fee covers initial onboarding, the printer kit, sticker supply, and
          welcome packet.
        </li>
        <li>
          <strong>Monthly usage:</strong> <strong>$1.00 USD per active car
          per month</strong>. Every active car is billed. Volume discounts
          apply automatically:{" "}
          <strong>200–499 cars at $0.90/car</strong> (10% off),{" "}
          <strong>500–999 cars at $0.85/car</strong> (15% off),{" "}
          <strong>1000+ cars</strong> require a custom quote — please
          contact ScanMint.
        </li>
        <li>
          <strong>First month free:</strong> The first 30 days after the
          setup fee is paid are <strong>free of monthly charges</strong>.
          Recurring monthly invoices begin after the free period ends.
        </li>
        <li>
          <strong>Prepaid &amp; recurring:</strong> Monthly usage is prepaid.
          Invoices are issued from your billing email and are due on receipt
          unless otherwise stated on the invoice.
        </li>
        <li>
          <strong>Payment methods:</strong> Card and US bank (ACH) payments are
          accepted through Stripe. ACH payments may take several business days
          to clear and will appear as &quot;processing&quot; until settled.
        </li>
        <li>
          <strong>Taxes:</strong> Listed prices do not include taxes that may
          apply in your jurisdiction.
        </li>
      </ul>

      <h2>4. Invoices &amp; suspension for non-payment</h2>
      <p>
        If an invoice remains unpaid past its grace period, ScanMint may{" "}
        <strong>suspend QR access</strong> for the affected property. Public
        scan pages will continue to load but will display a suspended state and
        will not reveal verification details until the outstanding balance is
        settled. Service is restored automatically once payment clears.
      </p>

      <h2>5. No long-term contract — cancel anytime</h2>
      <p>
        ScanMint is offered on a month-to-month basis. You may cancel at any
        time from the Settings screen or by contacting support. Cancellation
        stops future monthly charges; the current billing period is not
        prorated.
      </p>

      <h2>6. Customer data &amp; acceptable use</h2>
      <p>
        You retain ownership of the customer data you upload, including tenant
        and vehicle information. You agree that you have the right to upload
        that data and to display it on ScanMint public scan pages for the
        purpose of verification. You agree not to use ScanMint to harass
        individuals, store sensitive categories of data not necessary for
        verification, or violate applicable laws.
      </p>

      <h2>7. Service availability</h2>
      <p>
        We work to keep ScanMint available and reliable, but the service is
        provided on an &quot;as is&quot; and &quot;as available&quot; basis. We
        do not guarantee uninterrupted operation and may perform maintenance
        from time to time.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, ScanMint will not be liable for
        any indirect, incidental, or consequential damages, or for lost profits
        or lost data. Our total liability for any claim is limited to the
        amounts you paid to ScanMint in the 12 months preceding the claim.
      </p>

      <h2>9. Termination</h2>
      <p>
        We may suspend or terminate accounts that violate these Terms, that
        attempt to abuse the platform, or that have an unresolved past-due
        balance. You may terminate your account at any time as described in
        Section 5.
      </p>

      <h2>10. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. Material changes will be
        announced through the dashboard or by email. Continued use of ScanMint
        after the changes take effect constitutes acceptance of the updated
        Terms.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about these Terms can be sent to{" "}
        <a href="mailto:support@scanmint.app">support@scanmint.app</a>.
      </p>
    </LegalLayout>
  );
}
